import Graphlogo from "./icon_dashboard.svg";
import cartLogo from "./icon_orders.svg";
import msgLogo from "./message_icon.svg";
import productLogo from "./icon_products.svg";
import salesIcon from "./icon_sales.svg";
import settingIcon from "./setting_icon.svg";
import signoutIcon from "./icon_logout.svg";
import leaderIcon from "./icon_leaderboard.svg";
import searchIcon from "./magnifierIcon.svg";
import langIcon from "./langIcon.svg";
import dropdownIcon from "./dropDownIcon.svg";
import bellIcon from "./notificationIcon.svg";
import profilePic from "./profilePic.jpg";
import ovalblue from "./ovalIcon_blue.svg";
import ovalgreen from "./ovalIcon_green.svg";
import targetSales from "./target_sales.svg";
import realSales from "./realSales.svg";
import rectGreen from "./RectangleCopyGreen.svg";
import rectBlue from "./RectangleCopyBlue.svg";
import notFound from "./notfound.png";

import sunIcon from "./icon_sun.svg";
import moonIcon from "./icon_moon.svg";

const logos = {
	graphLogo: Graphlogo,
	cartLogo: cartLogo,
	msgLogo: msgLogo,
	productLogo: productLogo,
	salesIcon: salesIcon,
	settingIcon: settingIcon,
	signoutIcon: signoutIcon,
	leaderIcon: leaderIcon,
	searchIcon: searchIcon,
	langIcon: langIcon,
	dropdownIcon: dropdownIcon,
	bellIcon: bellIcon,
	profilePic: profilePic,
	ovalblue: ovalblue,
	ovalgreen: ovalgreen,
	targetSales: targetSales,
	realSales: realSales,
	rectGreen: rectGreen,
	rectBlue: rectBlue,
	notFound: notFound,
	sunIcon: sunIcon,
	moonIcon: moonIcon,
};

export default logos;
